import { Field, Image, ImageField, Link, LinkField, RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './RcnFoundationPromotion.module.css';

type RcnFoundationPromotionProps = ComponentProps & {
	fields: {
		Logo: ImageField;
		Title: Field<string>;
		PromotionText: Field<string>;
		Link: LinkField;
	};
};

export default function RcnFoundationPromotion(props: RcnFoundationPromotionProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields) {
		return <></>;
	}

	return (
		<div className="maxWidth pad">
			<div className={styles.contentOverviewGrantPromotionContainer}>
				<Image media={props.fields?.Logo} className={styles.logo} />

				<div className={styles.textContainer}>
					<Text tag="h1" field={props.fields?.Title} className={styles.title} />

					<RichText field={props.fields?.PromotionText} className={styles.text} />
				</div>

				<Link field={props.fields?.Link} className={styles.link} />
			</div>
		</div>
	);
}
